import Vue from "vue";
import Router from "vue-router";

const _import = require("./_import_" + process.env.NODE_ENV);
Vue.use(Router);

export default new Router({
  linkActiveClass: "router-link-active",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  mode: "history", //history   hash
  routes: [
    {
      path: "/",
      name: "index",
      component: _import("index/index"),
      redirect: { name: "home" },
      children: [
        { path: "home", name: "home", component: _import("home/home") },
        {
          path: "aboutUs",
          name: "aboutUs",
          component: _import("aboutUs/aboutUs")
        },
        {
          path: "joinUs",
          name: "joinUs",
          component: _import("joinUs/joinUs")
        },
        {
          path: "groupindustry",
          name: "groupindustry",
          component: _import("groupindustry/groupindustry"),
          redirect: { name: "realestate" },
          children: [
            {
              path: "realestate",
              name: "realestate",
              component: _import("groupindustry/realestate")
            },
            {
                path: "realestateDetail",
                name: "realestateDetail",
                component: _import("groupindustry/realestateDetail")
              },
            
            {
              path: "medicalCare",
              name: "medicalCare",
              component: _import("groupindustry/medicalCare")
            }
          ]
        },
        // {
        //   path: "healthCare",
        //   name: "healthCare",
        //   component: _import("healthCare/healthCare"),
        //   redirect: { name: "register" },
        //   children: [
        //     {
        //       path: "register",
        //       name: "register",
        //       component: _import("healthCare/register")
        //     },
        //     {
        //       path: "checkIn",
        //       name: "checkIn",
        //       component: _import("healthCare/checkIn")
        //     },
        //     {
        //       path: "specialistClinic",
        //       name: "specialistClinic",
        //       component: _import("healthCare/specialistClinic")
        //     },
        //     {
        //       path: "myCenter",
        //       name: "myCenter",
        //       component: _import("healthCare/myCenter")
        //     }
        //   ]
        // },
        {
          path: "concatUs",
          name: "concatUs",
          component: _import("concatUs/concatUs")
        }
      ]
    },
    // 报告列表|
    {
      path: "/reportList",
      name: "reportList",
      component: _import("reportList/reportList"),
      meta: {}
    },
    // 报告详情
    {
      path: "/reportDetail",
      name: "reportDetail",
      component: _import("reportList/reportDetail"),
      meta: {}
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js